import { loadingProgress } from '~/data/reducers/taxonomies';

const getState = (store) => store.taxonomies;

export const getList = (store) => getState(store).get('items');

export const itemsLoaded = (store) => loadingProgress.getLoaded(getState(store));
